import {existsLastLoggedInUserCookie} from "./globalUtils";

export class NthIterationExecutor {
    private readonly funcToExecute: (...args)=>void;
    private readonly executeEveryNthStep;
    private counter = 0;

    public constructor(funcToExecute:(...args)=>void, executeEveryNthStep = 5) {
        this.funcToExecute = funcToExecute;
        this.executeEveryNthStep =  executeEveryNthStep;
    }

    public execute(...args) {
        this.counter = (existsLastLoggedInUserCookie()===true) ? this.counter+1 : 1;
        if(this.counter % this.executeEveryNthStep === 1) {
            this.funcToExecute(...args);
        }
    }
}
